import { createAction } from 'redux-actions'

const SET_SESSIONS = 'SET_SESSIONS'
const RESET_SESSIONS = 'RESET_SESSIONS'

const actions = {
    setSessions: createAction(SET_SESSIONS),
    resetSessions: createAction(RESET_SESSIONS),
}

const types = {
    SET_SESSIONS,
    RESET_SESSIONS
}

export { actions, types }



// WEBPACK FOOTER //
// ./src/store/actions/sessions.js